{
  "AGENT_BOTS": {
    "HEADER": "Botovi",
    "LOADING_EDITOR": "Otvaranje Editora...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Saznajte više o botovima agenata",
    "GLOBAL_BOT": "Sistemski bot",
    "GLOBAL_BOT_BADGE": "Sistemski",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar bota uspješno izbrisan",
      "ERROR_DELETE": "Greška pri brisanju avatara bota, pokušajte ponovno"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Izaberi agentskog bota",
      "DESC": "Dodijelite Agent Bot svojoj pristigloj pošti. Oni mogu voditi početne razgovore i prebaciti ih živom agentu kada je to potrebno.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Ažuriraj",
      "DISCONNECT": "Isključi Bota",
      "SUCCESS_MESSAGE": "Uspješno ažuriran agentski bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Uspješno isključen agentski bot.",
      "ERROR_MESSAGE": "Nije moguće ažurirati agentskog bota, molimo pokušajte ponovno.",
      "DISCONNECTED_ERROR_MESSAGE": "Nije moguće ažurirati agentskog bota, molimo pokušajte ponovno.",
      "SELECT_PLACEHOLDER": "Izaberi Bota",
      "COUNTRY_BOTS": {
        "TITLE": "Botovi po državi",
        "DESC": "Ovaj inbox služi više država. Razgovor ide botu svoje države: prema trgovini na Kauflandu, tržnici Allegro narudžbe ili, inače, jeziku na kojem kupac piše. Svi ostali razgovori idu zadanom botu iznad.",
        "COUNTRY": "Odaberite državu",
        "BOT": "Izaberi Bota",
        "ADD": "Dodaj bota za državu",
        "REMOVE": "Ukloni",
        "DEFAULT_REQUIRED": "Prvo odaberite zadanog bota. Bot države zamjenjuje ga samo za tu državu.",
        "DISCONNECT_ALL": "Isključi sve botove"
      }
    },
    "ADD": {
      "TITLE": "Konfiguriraj novog bota",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "API": {
        "SUCCESS_MESSAGE": "Uspješno dodan Bot.",
        "ERROR_MESSAGE": "Nije moguće dodati bota, molimo pokušajte kasnije."
      }
    },
    "LIST": {
      "404": "Nije pronađen nijedan Bot, možeš kreirati Bota koristeći gumb 'Konfiguriraj novog bota' ↗",
      "LOADING": "Dohvat Botova...",
      "TABLE_HEADER": {
        "DETAILS": "Detalji bota",
        "URL": "Webhook URL"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "TITLE": "Izbriši Bota",
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati {name}?",
        "YES": "Da, izbriši",
        "NO": "Ne, zadrži"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot uspješno izbrisan.",
        "ERROR_MESSAGE": "Nije moguće izbrisati bota, molimo pokušajte ponovno."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Uredi",
      "TITLE": "Uredi Bota",
      "API": {
        "SUCCESS_MESSAGE": "Bot uspješno izbrisan.",
        "ERROR_MESSAGE": "Nije moguće ažurirati bota, molimo pokušajte ponovno."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar bota"
      },
      "NAME": {
        "LABEL": "Naziv bota",
        "PLACEHOLDER": "Unesite naziv bota",
        "REQUIRED": "Naziv bota je obavezan"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Što radi ovaj bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL je obavezan"
      },
      "ERRORS": {
        "NAME": "Naziv bota je obavezan",
        "URL": "Webhook URL je obavezan",
        "VALID_URL": "Unesite ispravan URL koji počinje s http:// ili https://"
      },
      "CANCEL": "Odustani",
      "CREATE": "Kreiraj bota",
      "UPDATE": "Ažuriraj bota"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Konfigurirajte webhook bota za integraciju s vašim prilagođenim servisima. Bot će primati i obrađivati događaje iz razgovora te na njih odgovarati."
    },
    "TYPES": {
      "WEBHOOK": "Webhook Bot"
    }
  }
}
